// src/layouts/MainLayout.tsx
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Divider,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEmpresa } from "../../context/empresa-context";
import { useAuth } from "../../context/auth-context";
import ResetPassword from "../ResetPassword";

function MainLayout() {
  const { logout, cliente } = useAuth();
  const { empresa } = useEmpresa();

  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollDirection, setScrollDirection] = useState<"up" | "down">("up");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openDialog, setOpenDialog] = useState(false);

  const open = Boolean(anchorEl);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        setScrollDirection("down");
      } else {
        setScrollDirection("up");
      }

      setIsScrolled(currentScrollY > 50);
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);

  const handleMenuClose = () => setAnchorEl(null);

  const handleChangePassword = () => {
    handleMenuClose();
    setOpenDialog(true);
  };

  const handleDialogClose = () => setOpenDialog(false);

  const handleLogout = () => logout();

  return (
    <Box sx={{ position: "relative" }}>
      {/* Header dinámico */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: isScrolled ? "rgba(254, 202, 202, 0.7)" : "#b91c1c",
          boxShadow: isScrolled ? "0px 4px 10px rgba(0, 0, 0, 0.1)" : "none",
          transform:
            scrollDirection === "down" ? "translateY(-100%)" : "translateY(0)",
          transition: "all 0.3s ease",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="body2">{empresa?.nombre}</Typography>
            <Typography variant="h6" sx={{ color: "white" }}>
              Bienvenido(a),{" "}
              <span style={{ color: "#ffffff" }}>{cliente?.nombre}</span>
            </Typography>
          </Box>
          <Box>
            <Button
              variant="text"
              sx={{ color: "white" }}
              onClick={handleMenuClick}
            >
              <Avatar
                src={empresa?.logo_empresa}
                alt={empresa?.nombre}
                sx={{ color: "white", bgcolor: "white" }}
              />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              PaperProps={{
                sx: {
                  boxShadow: "0px 15px 20px 0px rgba(82, 81, 81, 0.2)",
                  padding: 1,
                },
              }}
            >
              <MenuItem onClick={handleChangePassword} sx={{ borderRadius: 1 }}>
                Cambiar Contraseña
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleLogout} sx={{ borderRadius: 1 }}>
                Cerrar Sesión
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Contenido principal */}
      <Box component="main" sx={{ mt: 7, p: 2 }}>
        <Outlet />
      </Box>

      {/* Modal para cambiar contraseña */}
      <ResetPassword
        openDialog={openDialog}
        handleDialogClose={handleDialogClose}
      />
    </Box>
  );
}

export default MainLayout;
